<template>
  <div>
    <div class="page_title">门店合作申请详情</div>
    <div class="form_container">
      <form class="form">
        <div class="form_row">
          <div class="label">openId</div>
          <input class="input" disabled placeholder="openId" v-model="partner.userAccount">
        </div>
        <div class="form_row">
          <div class="label">联系人</div>
          <input class="input" placeholder="联系人" v-model="partner.contact">
        </div>
        <div class="form_row">
          <div class="label">电话号码</div>
          <input class="input" placeholder="电话号码" v-model="partner.phone">
        </div>
        <div class="form_row">
          <div class="label">省市区</div>
          <div class="form_value">
            <select class="pullDown" @change="changeProvince" v-model="currentProvince">
              <option v-for="(item,index) of provinces" :key="index" :value="item.name">
                {{ item.name }}
              </option>
            </select>
            <select class="pullDown" @change="changeCity" v-model="currentCity">
              <option v-for="(item,index) of citys" :key="index" :value="item.name">
                {{ item.name }}
              </option>
            </select>
            <select class="pullDown" v-model="currentDistrict">
              <option v-for="(item,index) of districts" :key="index" :value="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>
        <div class="form_row">
          <div class="label">地址</div>
          <input class="input" placeholder="地址" v-model="partner.address">
        </div>
        <div class="form_row">
          <div class="label">服务类型</div>
          <select class="pullDown" v-model="partner.washerType">
            <option v-for="item of washerTypeList" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="form_row">
          <div class="label">期待服务</div>
          <input class="input" placeholder="期待服务" v-model="partner.expectService">
        </div>
        <div class="form_row">
          <div class="label">申请时间</div>
          <input class="input" placeholder="申请时间" v-model="partner.createTime">
        </div>
        <div class="form_row">
          <div class="label">备注</div>
          <input class="input" placeholder="备注" v-model="partner.applyRemarks">
        </div>
      </form>
    </div>
    <div v-if="partner.applyState == 0" class="button_grounp">
      <van-button class="button refuse" @click="submit(-1)">拒绝</van-button>
      <van-button class="button approve" @click="submit(1)">通过</van-button>
    </div>
  </div>
</template>

<script>
import {getArea, modPosJoinApply} from "../api";
export default {
  name: "partner_detail",
  mounted() {
    this.partner = this.$route.params.partner;

    console.log('当前商家信息', this.partner);

    getArea().then(res => {
      console.log('查询到全国省市区信息', res);
      this.provinces = res.data;
      this.citys = this.provinces[0].city;
      this.districts = this.citys[0].area;
      this.focusArea();
    })

    this.currentProvince = this.partner.province;
    this.currentCity = this.partner.city;
    this.currentDistrict = this.partner.district;

  },
  data() {
    return {
      provinces: [],  //省
      citys: [],      //市
      districts: [],  //区
      currentProvince: null, //当前省份
      province: '',
      currentCity: null,     //当前城市
      city: '',
      currentDistrict: null, //当前区
      district: '',

      // 商户对象
      partner: {
        address: "王府井",
        applyRemarks: "",
        applyState: "",
        approver: "",
        city: "",
        contact: "",
        createTime: "",
        deviceInfo: "",
        district: "",
        expectService: "",
        id: "",
        modifyTime: "",
        phone: "",
        province: "",
        userAccount: "",
        washerType: ""
      },
      washerTypeList: [
        {
          id: 0,
          name: '智能洗车'
        },
        {
          id: 1,
          name: '自助洗车'
        },
        {
          id: 2,
          name: '人工洗车'
        }
      ]
    }
  },
  methods: {
    // 切换省份
    changeProvince() {
      for (const item of this.provinces) {
        if (item.name == this.currentProvince) {
          this.citys = item.city;
          this.currentCity = this.citys[0].name
          this.districts = this.citys[0].area;
          this.currentDistrict = this.districts[0];
        }
      }
    },

    // 切换城市
    changeCity() {
      for (const item of this.citys) {
        if (item.name == this.currentCity) {
          this.districts = item.area;
          this.currentDistrict = this.districts[0]
        }
      }
    },

    // 重定向省市区
    focusArea() {
      for (const item of this.provinces) {
        if (item.name == this.currentProvince) {
          this.citys = item.city;
          this.districts = this.citys[0].area;
          console.log('当前城市列表为', this.citys);
        }
      }
      for (const item of this.citys) {
        if (item.name == this.currentCity) {
          this.districts = item.area;
          console.log('当前区列表为', this.districts);
        }
      }
    },

    // 提交网点合作申请的修改
    submit(applyState) {
      let applyId = Number(this.partner.id);
      let params = {
        province: this.currentProvince,
        city: this.currentCity,
        district: this.currentDistrict,
        address: this.partner.address,
        washerType: this.partner.washerType,
        deviceInfo: this.partner.deviceInfo,
        expectService: this.partner.expectService,
        contact: this.partner.contact,
        phone: this.partner.phone,
        applyState: applyState,
        applyRemarks: this.partner.applyRemarks
      }
      modPosJoinApply(applyId, params).then(res => {
        if (res.data.retcode == 0) {
          if (applyState == -1) {
            alert(`驳回成功`);
          } else {
            alert(`批准完成`)
          }
          this.$router.go(-1);
        }
      }).catch(error => {
        alert(`异常${error}`)
      })
    }
  }
}
</script>

<style src="../css/partner_detail.css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/partner_detail.vue